// import store from '@/store'
// import moment from 'moment'

export class CheckListsHelper {
  static validateCheckList (checkList) {
    let arr = []
    if (!checkList || !checkList.checks || !checkList.checks.length) {
      arr.push('check list invalid')
    }
    for (let check of checkList.checks) {
      let valid = this.validateCheck(check)
      if (valid !== true) {
        arr.push(valid)
      }
    }
    return arr
  }

  static validateCheck (check) {
    if (!check.value) check.value = ''
    if (!check.comment) check.comment = ''

    let value = check.value.trim()
    let comment = check.comment.trim()
    switch (check.type) {
      case 'checkbox':
        if (!value.length) {
          return `"${check.name}" is required`
        } else if (value === 'no' && check.requiredIfFalse && !comment.length) {
          return `"${check.name}" requires a comment if not checked`
        }
        break

      default:
        if (check.mandatory && !value.length) {
          return `"${check.name}" is required`
        }
        break
    }
    return true
  }

  static getBlankCheckList () {
    return {
      name: '',
      requiresSmu: true,
      description: '',
      checks: []
    }
  }

  static getBlankCheck () {
    return {
      name: '',
      type: 'checkbox',
      showComment: false,
      requiredIfFalse: false,
      allowNa: true,
      mandatory: false,
      value: '',
      comment: ''
    }
  }
}
